import { render, staticRenderFns } from "./ImageMosaicItem.vue?vue&type=template&id=20a3afc5&"
import script from "./ImageMosaicItem.vue?vue&type=script&lang=js&"
export * from "./ImageMosaicItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageMosaicItem.vue?vue&type=style&index=0&id=20a3afc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports